import type { ReactNode } from 'react';

export const symbol_view_apps: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M75-166q-14 2-24.5-6.5T40-195v-570q0-14 10.5-22.5T75-794l171 28q11 2 18 10t7 19v514q0 11-7 19t-18 10L75-166Zm316-33q-13 0-21.5-8.5T361-229v-501q0-13 8.5-21.5T391-760h178q13 0 21.5 8.5T599-730v501q0 13-8.5 21.5T569-199H391Zm323 5q-11-2-18-10t-7-19v-514q0-11 7-19t18-10l171-28q14-2 24.5 6.5T920-765v570q0 14-10.5 22.5T885-166l-171-28Zm-614-37 111-19v-461l-111-18v498Zm321-28h118v-441H421v441Zm439 28v-498l-111 18v462l111 18Zm-760 0 111-19-111 19Zm321-28h118-118Zm439 28-111-18 111 18Z"
		/>
	</svg>
);
